const _messageTitle = {
  computed: {
    ...Vuex.mapState(['user']),
  },
  props: {
    link: { default: false },
    thread: { default: {} },
  },
  methods: {
    isMyApplication() {
      return (
        this.thread.origin === 'jobs' && this.thread.owner === this.user._id
      );
    },
    getUser() {
      //si no hay link, o es mi perfil, no enlazamos
      if (!this.link || this.thread.ref._id === this.user.profile) {
        return this.thread.receiver.username;
      }

      if (this.thread.origin === 'jobs') {
        return `<a href="/directorio/${this.thread.ref.profile}" target="_blank">${this.thread.receiver.username}</a>`;
      } else {
        return `<a href="/directorio/${this.thread.ref._id}" target="_blank">${this.thread.receiver.username}</a>`;
      }
    },
    getTitle() {
      if (this.thread.origin === 'jobs') {
        if (this.link) {
          return this.user._id === this.thread.owner
            ? `<a href="/empleo/redirect/?jid=${this.thread.ref.job._id}" target="_blank">${this.thread.title}</a>`
            : `Se ha inscrito en <a href="#/empleo/${this.thread.ref.job._id}">${this.thread.title}</a>`;
        } else {
          return this.user._id === this.thread.owner
            ? this.thread.title
            : `Se ha inscrito en <strong>${this.thread.title}</strong>`;
        }
      } else if (this.thread.origin === 'profiles') {
        return this.user._id === this.thread.owner
          ? 'Le has enviado un mensaje'
          : 'Te ha enviado un mensaje';
      }
    },
  },
  template: `
      <div v-if="thread">
      <template v-if="isMyApplication()">
        <strong v-html="getTitle()" class="uk-display-block uk-text-truncate uk-title"></strong>
        <small>Oferta publicada por <strong>{{ thread.receiver.username }}</strong></small>
      </template>
      <template v-else>
        <strong v-html="getUser()" class="uk-display-block uk-text-truncate uk-title"></strong>
        <small v-html="getTitle()" class="uk-display-block uk-text-truncate"></small>
      </template>
      </div>
	`,
};
